import React, { Component } from 'react'

class TableTitle extends Component {

    render() {
        return (
            <React.Fragment>
                {!this.props.developperView && this.props.title && <h5>{this.props.title}</h5>}
                {this.props.developperView && <h6>{this.props.fieldname}</h6>}
            </React.Fragment>
        )
    }
}

export default (TableTitle)
